var React = require('react');

function CheckCircleFill (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996ZM14.1281 8.84832C14.5276 8.46698 14.5423 7.83399 14.1609 7.43449C13.7796 7.03499 13.1466 7.02026 12.7471 7.4016L8.85423 11.1175L7.25306 9.58911C6.85357 9.20777 6.22057 9.22248 5.83923 9.62198C5.45789 10.0215 5.47261 10.6545 5.8721 11.0358L8.16374 13.2233C8.55017 13.5922 9.15827 13.5922 9.5447 13.2233L14.1281 8.84832Z","fill":"currentColor"}));
}

CheckCircleFill.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckCircleFill;

CheckCircleFill.default = CheckCircleFill;
